// Carries the conversationId and messageId for the current Bizy answer so
// deep evidence components (export bar, table shell, sort, source-details) can
// stamp interaction analytics without prop-drilling through every layer.
import { createContext, useContext } from 'react';

interface BizyEvidenceAnalytics {
	conversationId?: string;
	messageId?: string;
}

const BizyEvidenceAnalyticsContext = createContext<BizyEvidenceAnalytics>({});

export const BizyEvidenceAnalyticsProvider = BizyEvidenceAnalyticsContext.Provider;

export function useBizyEvidenceAnalytics(): BizyEvidenceAnalytics {
	return useContext(BizyEvidenceAnalyticsContext);
}
